import * as Yup from "yup";
import { FUEL_TYPE, SAME_SUPPLIER, SUPPLIER_FUEL_TYPE } from "../constants/tariffInfo";
import EN from "../locales/en";

const createEditTariffFormYupSchema = () => {
  const FuelTypeMapping = {
    [FUEL_TYPE.ELECGAS]: ["electricity", "gas"],
    [FUEL_TYPE.ELEC]: ["electricity"],
    [FUEL_TYPE.GAS]: ["gas"],
    [SUPPLIER_FUEL_TYPE.ELECGAS]: ["electricity", "gas"],
    [SUPPLIER_FUEL_TYPE.ELEC]: ["electricity"],
    [SUPPLIER_FUEL_TYPE.GAS]: ["gas"],
  };

  return Yup.object({
    fuelTypes: Yup.string().required("Fuel type is required"),

    sameSupplier: Yup.string().when("fuelTypes", {
      is: (fuelTypes) => fuelTypes === FUEL_TYPE.ELECGAS,
      then: () => Yup.string().required("Required field"),
    }),

    sameTariff: Yup.string().when(["fuelTypes", "sameSupplier"], {
      is: (fuelTypes, sameSupplier) =>
        fuelTypes === FUEL_TYPE.ELECGAS &&
        sameSupplier === SAME_SUPPLIER.SINGLE,
      then: () => Yup.string().required("Required field"),
    }),

    tariffs: Yup.array()
      .of(
        Yup.object({
          fuel: Yup.string(),
          meterType: Yup.string().when("fuel", {
            is: (fuel) => fuel && FuelTypeMapping[fuel].includes(fuel),
            then: () => Yup.string().required("Meter type is required"),
          }),
          supplierName: Yup.string().when("fuel", {
            is: (fuel) => fuel && FuelTypeMapping[fuel].includes(fuel),
            then: () => Yup.string().required("Supplier name is required"),
          }),
          paymentMethod: Yup.string().when("fuel", {
            is: (fuel) => fuel && FuelTypeMapping[fuel].includes(fuel),
            then: () => Yup.string().required("Payment method is required"),
          }),
          tariffName: Yup.string().when("fuel", {
            is: (fuel) => fuel && FuelTypeMapping[fuel].includes(fuel),
            then: () => Yup.string().required("Tariff name is required"),
          }),
          estimatedUsage: Yup.object({
            value: Yup.number()
              .typeError("Usage value is required")
              .test(
                "is-required-based-on-fuels",
                "Usage value is required",
                function (value) {
                  const targetFuel = this.from[1].value.fuel;
                  if (targetFuel && FuelTypeMapping[targetFuel].includes(targetFuel)) {
                    return value !== undefined && value !== null;
                  }
                  return true;
                }
              )
              .moreThan(0, EN.edit_tariff_form.usage.zero_error)
              .max(1000000, EN.edit_tariff_form.usage.too_high_error)
              .test(
                "maxDigitsAfterDecimal",
                "Usage value must have at most 2 decimal places",
                function (value) {
                  const targetFuel = this.from[1].value.fuel;
                  if (targetFuel && FuelTypeMapping[targetFuel].includes(targetFuel)) {
                    return /^[0-9]*(\.[0-9]{0,2})?$/.test(parseFloat(value));
                  }
                  return true;
                }
              ),
          }),
        })
      )
      .test(
        "is-electricity-and-gas-tariff",
        "Electricity and gas tariffs are required",
        function () {
          const fuelTypes = this.parent.fuelTypes;
          const tariffs = this.parent.tariffs;
          if (fuelTypes === FUEL_TYPE.ELECGAS) {
            return tariffs.length === 2;
          }
          return true;
        }
      ),
  });
};

export default createEditTariffFormYupSchema;
